// Centralized API helper for Transiter

// Helper to join URLs safely
function joinUrl(base, ...parts) {
  return base.replace(/\/$/, '') + '/' + parts.map(p => p.replace(/^\//, '')).join('/');
}

export const API_BASE =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "/systems"
    : "https://corsproxy.io/?https://demo.transiter.dev/systems";
export const SYSTEM_ID = "us-ny-subway";

export async function fetchStops(systemId = SYSTEM_ID) {
  const url = joinUrl(API_BASE, systemId, "stops");
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch stops");
  return res.json();
}

export async function fetchArrivals(systemId, stopId) {
  const url = joinUrl(API_BASE, systemId, "stops", stopId);
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch arrivals");
  return res.json();
}

export async function fetchRoutes(systemId = SYSTEM_ID) {
  const url = joinUrl(API_BASE, systemId, "routes");
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch routes");
  return res.json();
} 